var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12", md: "3" } },
    [
      _c(
        "v-card",
        { staticClass: "ma-1" },
        [
          _c(
            "v-card-title",
            { staticClass: "title font-weight-black" },
            [
              _c("v-icon", { staticClass: "pr-3" }, [_vm._v("local_offer")]),
              _vm._v(" News & Offers\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-btn", { attrs: { block: "", disabled: "", href: "" } }, [
                _vm._v("Bulk offers"),
              ]),
              _vm._v(" "),
              _c("v-btn", { attrs: { block: "", disabled: "", href: "" } }, [
                _vm._v("New hotels"),
              ]),
              _vm._v(" "),
              _c("v-btn", { attrs: { block: "", href: "/newsletters/list" } }, [
                _vm._v("Newsletters"),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { block: "", href: "/press-releases/list" } },
                [_vm._v("Press releases")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { block: "", href: "/press-comments/list" } },
                [_vm._v("Press comments")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { block: "", href: "/competitions/list" } },
                [_c("v-icon", [_vm._v("star")]), _vm._v(" Competitions")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { block: "", href: "/promotions/list" } },
                [_c("v-icon", [_vm._v("local_offer")]), _vm._v(" Promotions")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { block: "", href: "/promotional-hotels/list" } },
                [
                  _c("v-icon", [_vm._v("local_offer")]),
                  _vm._v(" Promotional hotels"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }